import { useCallback, useSyncExternalStore } from "react";

import type {
  AnnotationRenderSourceRef,
  AnnotationStudioController,
  CapturedFrameRenderResource,
} from "./types";

export function useCapturedFrameRenderResource(
  controller: AnnotationStudioController,
  ref: AnnotationRenderSourceRef | null,
): CapturedFrameRenderResource | null {
  const getSnapshot = useCallback(
    () => (ref ? (controller.getCapturedFrameRenderResource?.(ref) ?? null) : null),
    [controller, ref],
  );
  const subscribe = useCallback(
    (listener: () => void) =>
      controller.subscribeCapturedFrameRenderResource?.(listener) ?? (() => undefined),
    [controller],
  );

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
